import { Button, Input, Popover, Space } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useCallback, useEffect, useState } from 'react';

const LinkEditorComponent = ({ componentId, editor }) => {
  const intl = useIntl();

  const [linkPopoverVisible, setLinkPopoverVisible] = useState(false);
  const [linkText, setLinkText] = useState('');
  const [linkUrl, setLinkUrl] = useState('');

  useEffect(() => {
    document.addEventListener('linkCommand', linkCommandListener);

    return () => {
      document.removeEventListener('linkCommand', linkCommandListener);
    }
  }, []);

  const linkCommandListener = (event) => {
    const eventId = event?.detail?.linkEditorComponentId;

    if (componentId !== eventId) {
      return;
    }

    setLinkPopoverVisible(true);
  }
  
  const handleLinkCreate = useCallback(() => {
    if (linkUrl.trim()) {
      const finalUrl = linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`;
      if (linkText.trim()) {
        editor.chain().focus().insertContent(`<a href="${finalUrl}">${linkText}</a>&nbsp;`).run();
      } else {
        editor.chain().focus().insertContent(`<a href="${finalUrl}">${finalUrl}</a>&nbsp;`).run();
      }
    }
    setLinkText('');
    setLinkUrl('');
    setLinkPopoverVisible(false);
  }, [editor, linkText, linkUrl]);

  const handleLinkCancel = useCallback(() => {
    setLinkText('');
    setLinkUrl('');
    setLinkPopoverVisible(false);
  }, []);

  const linkPopoverContent = (
    <div className="w-[300px] p-2">
      <Space direction="vertical" style={{ width: '100%' }}>
        <Input
          placeholder={intl.formatMessage({ id: 'ADD_TEXT', defaultMessage: 'Add text' })}
          value={linkText}
          onChange={(e) => setLinkText(e.target.value)}
          className="py-1"
        />
        <Input
          placeholder={intl.formatMessage({ id: 'ADD_URL', defaultMessage: 'Add Url' })}
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
          onPressEnter={handleLinkCreate}
          className="py-1"
        />
        <div className="flex justify-end gap-2 mt-2">
          <Button
            size="small"
            onClick={handleLinkCancel}
            className="!text-[12px]"
          >
            <FormattedMessage id="CANCEL" defaultMessage="Cancel" />
          </Button>
          <Button
            size="small"
            type="primary"
            onClick={handleLinkCreate}
            disabled={!linkUrl.trim()}
            className="!bg-blue-600 !text-[12px] !text-white"
          >
            <FormattedMessage id="ADD_LINK" defaultMessage="Add link" />
          </Button>
        </div>
      </Space>
    </div>
  );

  return (
    <Popover
      content={linkPopoverContent}
      trigger="click"
      open={linkPopoverVisible}
      onOpenChange={() => {}}
      placement="bottom"
    />
  );
}

export default LinkEditorComponent;
